function resolveEventScopeIds({
  isEventContext,
  eventId,
  workflowId,
  storedEventId,
  storedWorkflowId,
}) {
  const resolvedEventId = isEventContext ? eventId : storedEventId || eventId;
  const resolvedWorkflowId = isEventContext ? workflowId : storedWorkflowId || workflowId;

  if (resolvedEventId && resolvedWorkflowId) {
    return {
      eventId: resolvedEventId,
      workflowId: resolvedWorkflowId,
      playbookId: resolvedWorkflowId,
    };
  }

  return null;
}

/** Keep playbookId and workflowId in sync — same underlying id for backward compatibility. */
export function mirrorPlaybookAndWorkflowIds(payload) {
  if (!payload || typeof payload !== 'object') {
    return payload;
  }

  const sharedId = payload.workflowId || payload.playbookId;

  if (!sharedId) {
    return payload;
  }

  return {
    ...payload,
    workflowId: sharedId,
    playbookId: sharedId,
  };
}

/** Attach eventId + workflowId on create — events platform only. */
export function withEventScopeForCreate(payload, { isEventContext, eventId, workflowId }) {
  if (!isEventContext) {
    return mirrorPlaybookAndWorkflowIds(payload);
  }

  return mirrorPlaybookAndWorkflowIds({
    ...payload,
    eventId,
    workflowId,
    playbookId: workflowId,
  });
}

/** Attach eventId + workflowId on update — both portals when ids are available. */
export function withEventScopeForUpdate(
  payload,
  { isEventContext, eventId, workflowId },
  storedIds = {}
) {
  const ids = resolveEventScopeIds({
    isEventContext,
    eventId,
    workflowId,
    storedEventId: storedIds.eventId,
    storedWorkflowId: storedIds.workflowId,
  });

  if (!ids) {
    return mirrorPlaybookAndWorkflowIds(payload);
  }

  return mirrorPlaybookAndWorkflowIds({
    ...payload,
    ...ids,
  });
}
